import axios, { AxiosRequestConfig } from 'axios'
import { ASSETS_URL } from '@/config'
import api from '.'

export interface S3Response <T = any> {
  status: number,
  headers: any,
  data: T
}

const transport = axios.create({})
class S3Assets {
  constructor (baseUrl: string) {
    this.baseUrl = baseUrl
  }

  readonly baseUrl!: string

  private async request <T = any> (
    method: AxiosRequestConfig['method'],
    path: string,
    requestData?: any,
    additionalHeaders: { [key: string]: string } = {}) {
    try {
      const url = await this.generateAssetUrl(path)
      const data = await transport.request<T>({
        url,
        method,
        data: requestData,
        headers: Object.assign({
          Accept: 'json'
        }, additionalHeaders)
      })
      return Promise.resolve(data)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  public async generateAssetUrl (path: string, sign = true) {
    const url = this.baseUrl + path
    if (sign) {
      return await api.signAssetUrl(url)
    } else {
      return url
    }
  }

  async get (assetPath: string): Promise<S3Response> {
    return this.request('GET', assetPath)
  }

  async update (assetPath: string, payload: string): Promise<S3Response> {
    return this.request('PUT', assetPath, payload, {
      // ensure uploaded files belong to the bucket owner
      'x-amz-acl': 'bucket-owner-full-control'
    })
  }

  async upload (assetPath: string, file: File) {
    return this.request('PUT', assetPath, file, {
      'Content-Type': file.type || 'application/octet-stream',
      'x-amz-acl': 'bucket-owner-full-control'
    })
  }

  public urlIsFloopAsset (url: string) {
    const pastAndPresentBaseAssetUrls = [this.baseUrl, 'assets.alphahq.com']
    return !!pastAndPresentBaseAssetUrls.find(baseUrl => url.indexOf(baseUrl) > -1)
  }
}

export default new S3Assets(ASSETS_URL)
